import {
  parseServerDateTime,
  returnStringFormattedDateTime,
} from "@/lib/globalFormatterHelper";
import tradeDataStore from "@/store/tradeDataStore";

// LQC-2171/LQC-2172 - copy/paste and sort path for the Expires column. Always
// the absolute timestamp, never the countdown: pasting "5h 35m" into a
// spreadsheet is useless, and it would be wrong a second later.
//
// Reads the store so a copied value can't be staler than the rendered one,
// falling back to the grid's own value when the row isn't in the store (tests,
// mini tables). parseServerDateTime because expiryEnd arrives without a
// timezone designator (see docs/features/TRADE_EXPIRY.md).
export function expiresCellValueFormatter(params: any): string {
  const esid = params?.data?.esid;
  const thisTrade = esid
    ? tradeDataStore.getState().tradeData.find((trade) => trade.esid === esid)
    : undefined;

  const expiryEnd = parseServerDateTime(thisTrade?.expiryEnd ?? params?.value);
  return expiryEnd ? returnStringFormattedDateTime(expiryEnd) : "";
}
